import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["questionKey"];
import { PPUIPageHeader } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { FullProductLineMap } from 'self-service-api/constants/ProductLineMap';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import BannerSection from '../components/banners/BannerSection';
import ProductPageSubtitle from '../components/common/ProductPageSubtitle';
import ProductPageTitle from '../components/common/ProductPageTitle';
import ErrorBoundary from '../components/error-boundary/ErrorBoundary';
import { ERROR_SEVERITY } from '../components/error-boundary/error-severity';
import withErrorBoundary from '../components/error-boundary/withErrorBoundary';
import Faq from '../components/faqs/Faq';
import Question from '../components/faqs/Question';
import { FreeCard } from '../components/merch-card/cards/FreeCard';
import MobileSuiteFeatureTable from '../components/mobile/MobileSuiteFeatureTable';
import MobileCardWrapper from '../components/mobile/containers/MobileCardWrapper';
import MobileWrapper from '../components/mobile/containers/MobileWrapper';
import { FREE_TOOLS_PAGE, FREE_TOOLS_PAGE_CONTENT } from '../constants/ErrorBoundaryNames';
import { DEFAULT } from '../constants/ErrorCauses';
import { FaqsConfig } from '../constants/faqs/FaqsConfig';
import { NavItemEnum } from '../constants/routing/NavItems';
import { SCREENS } from '../constants/tracking/Screens';
import { FREE_CARD } from '../constants/tracking/TrackingSources';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { trackPageView } from '../utils/tracking/trackingEventUtils';
import ErrorPage from './ErrorPage';
import MissingInfoFallbackPage from './MissingInfoFallbackPage';
import { useAppSelector } from '../reducers';
import { isUngatedForInbound25Selector } from '../selectors/GatingSelectors';
import { View } from 'foundations-components/components/View';
import { CreditsCallout } from '../components/common/credits-callout/CreditsCallout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileFreeToolsPage = () => {
  const isUngatedForInbound = useAppSelector(isUngatedForInbound25Selector);
  useDocumentTitle('crm');
  useEffect(() => {
    trackPageView({
      screen: SCREENS.FREE
    });
  }, []);
  const marketingFreeProduct = FullProductLineMap[ProductLines.MARKETING].highlightedFreeProduct;
  const salesFreeProduct = FullProductLineMap[ProductLines.SALES].highlightedFreeProduct;
  const serviceFreeProduct = FullProductLineMap[ProductLines.SERVICE].highlightedFreeProduct;
  const operationsFreeProduct = FullProductLineMap[ProductLines.OPERATIONS].highlightedFreeProduct;
  const cmsFreeProduct = FullProductLineMap[ProductLines.CMS].highlightedFreeProduct;
  const commerceFreeProduct = FullProductLineMap[ProductLines.COMMERCE].highlightedFreeProduct;
  const productsByProductLine = {
    [ProductLines.MARKETING]: [marketingFreeProduct],
    [ProductLines.SALES]: [salesFreeProduct],
    [ProductLines.SERVICE]: [serviceFreeProduct],
    [ProductLines.OPERATIONS]: [operationsFreeProduct],
    [ProductLines.CMS]: [cmsFreeProduct],
    [ProductLines.COMMERCE]: [commerceFreeProduct]
  };
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    fallback: /*#__PURE__*/_jsx(MissingInfoFallbackPage, {
      navItem: NavItemEnum.FREE
    }),
    errorBoundaryName: FREE_TOOLS_PAGE_CONTENT,
    severity: ERROR_SEVERITY.HIGH,
    children: /*#__PURE__*/_jsxs(MobileWrapper, {
      navItem: NavItemEnum.FREE,
      navMarkerName: "FREE_TOOLS_PAGE",
      children: [/*#__PURE__*/_jsx(BannerSection, {
        screen: SCREENS.FREE
      }), /*#__PURE__*/_jsxs(PPUIPageHeader, {
        children: [/*#__PURE__*/_jsx(ProductPageTitle, {
          nonProductIdentifier: NavItemEnum.FREE
        }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
          nonProductIdentifier: NavItemEnum.FREE
        })]
      }), /*#__PURE__*/_jsxs(PageSection, {
        children: [/*#__PURE__*/_jsx(MobileCardWrapper, {
          children: /*#__PURE__*/_jsx(FreeCard, {
            productLine: "crm",
            columnStart: 1,
            trackingSource: FREE_CARD
          })
        }), isUngatedForInbound && /*#__PURE__*/_jsx(View, {
          marginBlock: "800",
          children: /*#__PURE__*/_jsx(CreditsCallout, {
            navItem: SCREENS.FREE
          })
        }), /*#__PURE__*/_jsx(MobileSuiteFeatureTable, {
          productLevel: FREE,
          productsByProductLine: productsByProductLine,
          screen: SCREENS.FREE
        })]
      }), /*#__PURE__*/_jsx(Faq, {
        children: FaqsConfig[NavItemEnum.FREE].map(_ref => {
          let {
              questionKey
            } = _ref,
            passthroughOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
          return /*#__PURE__*/_jsx(Question, Object.assign({
            questionKey: questionKey
          }, passthroughOptions), questionKey);
        })
      })]
    })
  });
};
export default withErrorBoundary(MobileFreeToolsPage, {
  FallbackComponent: () => /*#__PURE__*/_jsx(ErrorPage, {
    errorCause: DEFAULT
  }),
  errorBoundaryName: FREE_TOOLS_PAGE,
  severity: ERROR_SEVERITY.HIGH
});